export default "__VITE_ASSET__CWmBO42W__"